import type React from 'react';
import type { ComparisonCategory } from '~/components/routes/choose-subscription/placeholderSubscriptionComparisonData';
import type { ComparableSubscription } from '../../../../models/subscription-comparison/ComparableSubscriptions';

import { FeatureIcons } from '../images/featureIcons';
import './features-table.scss';
import styles from '../overview-list/SubscriptionFeatures.module.css';
import { FeatureIndicatorItem } from '../overview-list/SubscriptionFeatures';

interface Props {
  comparableSubscriptions: ComparableSubscription[];
  comparisonCategories: ComparisonCategory[];
}

export const FeaturesTable: React.FC<Props> = ({ comparableSubscriptions, comparisonCategories }) => {
  return (
    <table className="comparison-table" aria-label="Produktsammenligningstabell">
      <tbody>
        <tr className="subscription-names-wcag">
          <th scope="col">Egenskap</th>

          {comparableSubscriptions.map((subscription) => (
            <th key={subscription.name} scope="col">
              {subscription.name}
            </th>
          ))}
        </tr>

        {comparisonCategories.map((category) => {
          const Icon = FeatureIcons[category.icon];
          return (
          <tr key={category.name}>
            <th scope="row">
              <div className="feature-name">
                <Icon style={{width: '28px'}} />
                <span className={`feature ${category.icon} sub-body`}>{category.name}</span>
              </div>
            </th>

            {comparableSubscriptions.map((subscription) => {
              const feature = subscription.featureIndicators[category.type];
              return (
              <td key={subscription.name + category.name + feature.displayType}>
                <div className={styles.indicator}><FeatureIndicatorItem feature={feature} /></div> 
              </td>
            )})}
          </tr>
        )})}

        <tr className="bottom-row">
          <td />
          <td>
            <div />
          </td>
          <td>
            <div />
          </td>
          <td>
            <div />
          </td>
          <td>
            <div />
          </td>
        </tr>
      </tbody>
    </table>
  );
};
